import { inject, Injectable } from '@angular/core';
import { LoggerService } from '../logging/Logger.service';

export type StorageType = 'session' | 'local';

@Injectable({ providedIn: 'root' })
export class BrowserStorageService {
    private _logger = inject(LoggerService);

    getItem<T>(key: string, storage: StorageType = 'session'): T | null {
        try {
            const raw = this.getStorage(storage).getItem(key);
            return raw != null ? (JSON.parse(raw) as T) : null;
        } catch (e) {
            // Ignore access or parse errors; return null as fallback
            this._logger.warn(`Failed to get item from ${storage} storage:`, e);
            return null;
        }
    }

    setItem<T>(key: string, value: T, storage: StorageType = 'session'): void {
        try {
            this.getStorage(storage).setItem(key, JSON.stringify(value));
        } catch (e) {
            // Ignore quota or access errors
            this._logger.warn(`Failed to set item in ${storage} storage:`, e);
        }
    }

    removeItem(key: string, storage: StorageType = 'session'): void {
        try {
            this.getStorage(storage).removeItem(key);
        } catch {
            // Ignore access errors
        }
    }

    private getStorage(type: StorageType): Storage {
        return type === 'local' ? localStorage : sessionStorage;
    }
}
